import React from 'react'
import "./style.scss";
import {Card, Col, Row} from "react-bootstrap";

export const FollowTabButton = ({title = "", emoji = null, active = false, onPress = null}) => {
    return (
        <Card className={`followTabButton card p-2 ${active ? "followTabButton--active" : ""}`} onClick={onPress}>
            <div className="d-flex flex-row justify-content-center align-items-center mb-0 gap-0">
                <span className="fs-6">{emoji}</span>
                <span className="fs-6">{title}</span>
            </div>
        </Card>
    )
}
